/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { NgControl } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'

export class ErrorMessage {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any

  constructor(
    private control: NgControl,
    public translateService: TranslateService,
    public controlName?: string,
  ) {}

  get first() {
    if (!this.control.errors) {
      return
    }

    const firstKey = Object.keys(this.control.errors)[0]
    this.error = this.control.getError(firstKey)

    return this[firstKey]
  }

  get friendlyControlName(): string {
    const friendlyName = String(this.translateService.instant(`FIELDS.${this.control.name || this.controlName}`)).toLowerCase()
    return this.control.name || this.controlName ? friendlyName : ''
  }

  get required(): string {
    return <string>this.translateService.instant('ERRORS.REQUIRED', { field: this.friendlyControlName })
  }

  get email(): string {
    return <string>this.translateService.instant('ERRORS.EMAIL', { field: this.friendlyControlName })
  }

  get maxlength(): string {
    return <string>this.translateService.instant('ERRORS.MAX_LENGTH', {
      field: this.friendlyControlName,
      number: this.error.requiredLength,
    })
  }

  get minlength(): string {
    return <string>this.translateService.instant('ERRORS.MIN_LENGTH', {
      field: this.friendlyControlName,
      number: this.error.requiredLength,
    })
  }

  get existingName(): string {
    return <string>this.translateService.instant('ERRORS.EXISTING_NAME', { field: this.friendlyControlName })
  }

  get existingValue() {
    return <string>this.translateService.instant('ERRORS.EXISTING_VALUE', { field: this.friendlyControlName })
  }

  get unsignedInt(): string {
    return <string>this.translateService.instant('ERRORS.POSITIVE_INTEGER', { field: this.friendlyControlName })
  }

  get dateInFuture() {
    return <string>this.translateService.instant('ERRORS.DATE_IN_FUTURE', { field: this.friendlyControlName })
  }

  get macAddress(): string {
    return <string>this.translateService.instant('ERRORS.MAC_ADDRESS')
  }

  get maxValue(): string {
    return <string>this.translateService.instant('ERRORS.MAX_VALUE', {
      field: this.friendlyControlName,
      number: this.error,
    })
  }

  get minValue(): string {
    return <string>this.translateService.instant('ERRORS.MIN_VALUE', {
      field: this.friendlyControlName,
      number: this.error,
    })
  }

  get server() {
    return this.error
  }

  get phoneNumber(): string {
    return <string>this.translateService.instant('ERRORS.PHONE', {
      field: this.friendlyControlName,
    })
  }

  get yearNotValid(): string {
    return <string>this.translateService.instant('ERRORS.YEAR_NOT_VALID')
  }
}
